import React from "react";
import { Drawer } from 'components/common';
import PropTypes from "prop-types";
import { FaUserEdit } from "react-icons/fa";
import CustomerForm from "./CustomerForm";

/**
 * Slide-in Drawer wrapper around CustomerForm for editing a customer in place
 * (no full-page navigation). The form is keyed by customer id and only mounted
 * while the drawer is open, so it always hydrates fresh from the latest record.
 */
const EditCustomerDrawer = ({ show, onHide, customer, onSaved }) => (
  <Drawer
    show={show}
    onHide={onHide}
    title={<><FaUserEdit size={15} /> Edit Customer</>}
    width="60%"
    minWidth="640px"
    backdropClick={false}
  >
    {show && customer ? (
      <CustomerForm
        key={customer.id}
        embedded
        title="Edit Customer"
        customer={customer}
        onCancel={onHide}
        onSuccess={() => { onSaved?.(); onHide(); }}
      />
    ) : <></>}
  </Drawer>
);

EditCustomerDrawer.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  customer: PropTypes.object,
  onSaved: PropTypes.func,
};

export default EditCustomerDrawer;
